// extracted by mini-css-extract-plugin
export var iconContainer = "_g2-0";
export var metricCardsContainer = "_g2-1";